import React, { useState, useEffect, useRef } from 'react';
import { Card, Col, Input, List, Row, Tag, Modal } from 'antd';
import { Navbar } from "../Navigation/Navbar";
import { useSelector} from "react-redux";
import ReactPlayer from 'react-player/file';
import { TrainingAPI } from  "../../api/TrainingAPI";
import { useLocation } from "react-router-dom";
import { audioMessage as message } from "../Common/Notifications/audioMessage";

const { Meta } = Card;
const { CheckableTag } = Tag;

const custom_sort_categories = (categories) => {
  // new ordering: navbar tab categories first, in order of navbars, then all other created categories, then Other
  const navbarTabOrder = ["Overview", "Upload", "Team", "Players", "Breakdown", "Baselines", "Drills", "Leaderboard", "Scatterplot",  "Compare", "Reports", "DataViz AI", "Team Settings"];
  const lastTab = "Other";

  const ordered = navbarTabOrder.filter(el => categories.includes(el));
  const rest = categories.filter(el => !navbarTabOrder.includes(el) && el !== lastTab);
  const otherCategory = categories.includes(lastTab) ? [lastTab] : [];
  return [...ordered, ...rest, ...otherCategory];
}

export const HelpCenterPage = () => {

  const { misc: { help_center_videos, help_center_video_categories }} = useSelector(({ team }) => team);
  const [videoList, setVideoList] = useState(help_center_videos);
  const [videoPlayerIsOpen, setVideoPlayerIsOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState(undefined);
  const [selectedTags, setSelectedTags] = useState([]);
  const categories = custom_sort_categories(help_center_video_categories || []);

  const location = useLocation();
  const preselected_video = new URLSearchParams(location.search).get('video');

  const trainingAPI = new TrainingAPI();

  useEffect(() => {
    setVideoList(help_center_videos);

    if (preselected_video && help_center_videos) {
      if (help_center_videos?.map(x=>x.key)?.includes(preselected_video)) {
        handleClick(preselected_video);
      } else {
        message.error('Video not found');
      }
    }
  }, [help_center_videos]);

  useEffect(() => {
    if (selectedTags.length === 0) {
      setVideoList(help_center_videos);
    } else {
      const filtered_videos = help_center_videos.filter(video => selectedTags.includes(video.category));
      setVideoList(filtered_videos);
    }
  }, [selectedTags]);


  const handleSearchTextChange = (e) => {
    if (e.target.value?.trim() === '') {
      setVideoList(help_center_videos);
    }

    const lowerCaseSearchText = e.target.value.toLowerCase();
    const filtered_videos = help_center_videos.filter(video => {
        return (
          video.title.toLowerCase().includes(lowerCaseSearchText) ||
          video.category.toLowerCase().includes(lowerCaseSearchText) ||
          video.tags.some(tag => tag.toLowerCase().includes(lowerCaseSearchText))
        );
      });
    setVideoList(filtered_videos);
  }

  const emptyText = (<div>
    No videos found for this search. <br />Please reach out to us at support@gpsdataviz.com if you need further assistance.
  </div>)

  const handleClick = (video_key) => {
    trainingAPI.getHelpVideoUrl(video_key).then((response) => {
        setVideoUrl(response.presigned_url);
        setVideoPlayerIsOpen(true);
    }).catch(() => {
        message.error('Error loading video. Please try again later.');
    });
  }

  const VideoPlayerModal = () => {
    return (
      <div onContextMenu={(event) => event?.preventDefault()}>
        <ReactPlayer 
          url={videoUrl}
          controls
          width='100%'
          height='100%'
          playing={true}
          config={{ file: { attributes: { controlsList: 'nodownload' } } }}
        />
      </div>
    );
  };

  return (
    <>
        <Navbar />

        <Modal 
            open={videoPlayerIsOpen}
            footer={null}
            onCancel={() => {setVideoPlayerIsOpen(false); setVideoUrl(undefined)}}
            closable={false}
            width={'75vw'}
            destroyOnClose
            styles={{
                mask: {
                    backdropFilter: 'blur(10px)'
                }
            }}
            bodyStyle={{padding: 10}}
        >
            <VideoPlayerModal />
        </Modal>

        <Col style={{
            justifyItems: 'center',
            padding: 20,
            }}>

            <Row gutter={24}>
                <h1>Help Center</h1>
            </Row>

            <Row gutter={24}>
                <Input
                    placeholder="Search Help Videos"
                    style={{ width: 300, margin: 20 }}
                    allowClear
                    size='large'
                    onChange={handleSearchTextChange}
                />
            </Row>

            <Row gutter={24}>
              {categories.map((tag, index) => (
                <CheckableTag
                  key={`${tag}${index}`}
                  checked={selectedTags.includes(tag)}
                  onChange={(checked) => setSelectedTags(checked ? [tag] : [])}
                  style={{border: '1px solid #1790ff', borderRadius: 5}}
                >
                  {tag}
                </CheckableTag>
              ))}
            </Row>
            
            <Row gutter={24} style={{
                justifyContent: 'center', 
                marginTop: 20, 
                width: '100%',
                }}>
                <List
                    grid={{ column: 5, gutter: 10 }}
                    style={{ width: '90%' }}
                    dataSource={videoList}
                    locale={{emptyText: emptyText}}
                    renderItem={(item) => (
                        <div onClick={() => handleClick(item.key)}>
                        <List.Item style={{justifyItems: 'center'}}>
                            <Card
                                hoverable
                                style={{ 
                                    width: "100%",
                                    borderRadius: 15,
                                    overflow: 'hidden',
                                 }}
                                cover={<img alt="example" src={item.thumbnail || "https://cdn.dribbble.com/users/17914/screenshots/4902225/media/0d6d47739dae97adc81ca7076ee56cc9.png"} />}
                            >
                                <Meta title={item.title} description={item.category}/>
                            </Card>
                        </List.Item>
                        </div>
                    )}
                />
        </Row>
    </Col>
    </>
  );
};

export default HelpCenterPage;
